export const isNomi = (paymentSource: string) : boolean => {
    return (paymentSource === "nomi_ach" || paymentSource === "nomi_virtual_card" || paymentSource === "nomi_zero_paid")
}

interface paymentSourceMap {
    lob_check: string;
    nomi_ach: string;
    nomi_virtual_card: string;
    nomi_zero_paid: string;
}

export const paymentSourceObject: paymentSourceMap = {
    lob_check: 'Paper Check',
    nomi_ach: "NOMI ACH",
    nomi_virtual_card: 'NOMI Virtual Card',
    nomi_zero_paid: 'NOMI Zero Paid'
}

export type PaymentSource = keyof typeof paymentSourceObject

interface nomiPaymentMethodMap {
    PV_VIRTUAL_CARD: string;
    PV_BANK: string;
    PV_NULL: string;
    PV_OPT_OUT: string
}

export const nomiPaymentMethodObject: nomiPaymentMethodMap = {
    PV_BANK: "NOMI ACH",
    PV_VIRTUAL_CARD: 'NOMI Virtual Card',
    PV_NULL: "NOMI Zero Paid",
    PV_OPT_OUT: "NOMI Opted Out"
}

export type NomiPaymentMethod = keyof typeof nomiPaymentMethodObject